import React from 'react'
import './style.css'
import { BeforeWedding } from '../icons/BeforeWedding'
import { Wedding } from '../icons/Wedding'
import { BeforeRestaurant } from '../icons/BeforeRestaurant'
import { Restaurant } from '../icons/Restaurant'

export const Schedule = () => {
    return (
        <div className='Schedule'>
            <div className='Schedule__title'>
                Свадебное расписание
            </div>
            <div className='Schedule__container'>
                <div>
                    <div className='Schedule__item'>
                        <BeforeWedding className='Schedule__item_icon' />
                        <div className='Schedule__item_time'>
                            15:20<br />
                            06.08.2026
                        </div>
                        <div className='Schedule__item_text'>
                            Сбор гостей у Дворца бракосочетания №2<br />
                            <a href='https://yandex.com/maps/-/CDeIVA58' target='_blank' rel="noreferrer">Фурштатская улица, 52</a>
                        </div>
                    </div>
                    <div className='Schedule__item'>
                        <Wedding className='Schedule__item_icon' />
                        <div className='Schedule__item_time'>
                            15:40<br />
                            06.08.2026
                        </div>
                        <div className='Schedule__item_text'>
                            Роспись в Дворце бракосочетания №2 <br />
                            <a href='https://yandex.com/maps/-/CDeIVA58' target='_blank' rel="noreferrer">Фурштатская улица, 52</a>
                        </div>
                    </div>
                    <div className='Schedule__item'>
                        <BeforeRestaurant className='Schedule__item_icon' />
                        <div className='Schedule__item_time'>
                            17:30<br />
                            06.08.2026
                        </div>
                        <div className='Schedule__item_text'>
                            Сбор гостей в банкетном зале «Весенний»<br />
                            <a href='https://yandex.com/maps/-/CPqKIX2v' target='_blank' rel="noreferrer">Набережная реки Фонтанки, 108</a>
                        </div>
                    </div>
                    <div className='Schedule__item'>
                        <Restaurant className='Schedule__item_icon' />
                        <div className='Schedule__item_time'>
                            18:00<br />
                            06.08.2026
                        </div>
                        <div className='Schedule__item_text'>
                            Банкет <br />
                            <a href='https://yandex.com/maps/-/CPqKIX2v' target='_blank' rel="noreferrer">Набережная реки Фонтанки, 108</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
